/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";

export const mobileOrderConfirmationRequestSchema = z.object({
	order: z.uuid(),
});
